import PageHeader from '../components/PageHeader';

export default function SettingsPage() {
  return (
    <div>
      <PageHeader title="Settings" subtitle="Manage system, notifications, and permissions" />
      <p>Admin can manage notification settings, user roles, permissions, and security options.</p>
    </div>
  );
}
